import React, { useCallback, useMemo, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AdminContext from '@this/components/admin/context';

const TABS_FOR_AIT = [
  { path: '/admin/supplied_item_mappings', label: '検索商品' },
  { path: '/admin/individual_target_supplied_items', label: '国内航空券（株主優待券）' },
  { path: '/admin/individual_domestic_air_supplied_items', label: '国内航空券（発券方法別）' },
  { path: '/admin/individual_option_supplied_items', label: 'オプション設定' },
  { path: '/admin/individual_railway_supplied_items', label: '鉄道' }
];
const TABS = TABS_FOR_AIT.filter(t => t.path !== '/admin/individual_option_supplied_items');

const SuppliedItemMappingTabs: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const serviceId = useContext(AdminContext);
  const styles = useMemo(() => getStyles(), []);
  const tabs = utils.isAiTravel(serviceId) ? TABS_FOR_AIT : TABS;
  const tab = useMemo(() => tabs.find(t => t.path === location.pathname), [location.pathname, tabs]);

  const handleChange = useCallback(
    (path: string) => () => {
      if (path === '/admin/individual_railway_supplied_items') {
        const params = new URLSearchParams();
        params.set('tab', 'individual_railway_supplied_items');
        params.set('sub_tab', 'ticketing_method');
        history.push(`${path}?${params.toString()}`);
      } else {
        history.push(path);
      }
    },
    [history]
  );

  return (
    <div style={styles.filterInputArea}>
      {tabs.map(({ path, label }) => (
        <label key={path} style={styles.radioLabel}>
          <input
            type="radio"
            value={path}
            checked={path === tab?.path}
            onChange={handleChange(path)}
            style={styles.input}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
};

const getStyles = () => ({
  filterInputArea: {
    display: 'flex' as const,
    flexWrap: 'wrap' as const,
    marginBottom: 16
  },
  radioLabel: {
    display: 'flex' as const,
    marginRight: 10
  },
  input: {
    display: 'flex' as const,
    marginRight: 10
  }
});

export default SuppliedItemMappingTabs;
